import { render, staticRenderFns } from "./AdminApprovedStatus.vue?vue&type=template&id=0464f01e"
import script from "./AdminApprovedStatus.vue?vue&type=script&lang=js"
export * from "./AdminApprovedStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports